import React from 'react'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'
import SocialTop from '../../Components/Toasts/socialTop'

import CarouselB from '../../Components/Carousel/Featured/feat_carousel'
import Medic from '../../assets/images/medicine.png'

export default function home() {
  return (
    <>
      <SocialTop />
      <Navbar/>
      <CarouselB img1={Medic} img2={Medic} img3={Medic} />
      <Footer/>
    </>
  )
}
